// Hands the browser a generated document to save. The content is fetched
// by the caller (the API needs the bearer header a plain download link
// cannot carry), then offered through a temporary object URL.
export function saveTextFile(text: string, filename: string, type: string) {
  const url = URL.createObjectURL(new Blob([text], { type }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
